import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "boxed-widget opening-hours margin-top-35" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "listing-badge now-open" }, "Now Open", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", null, [
  /*#__PURE__*/_createVNode("i", { class: "sl sl-icon-clock" }),
  /*#__PURE__*/_createTextVNode(" Opening Hours")
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Monday ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Tuesday ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Wednesday ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Thursday ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Friday ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Saturday ")
const _hoisted_10 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createTextVNode("Sunday "),
  /*#__PURE__*/_createVNode("span", null, "Closed")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("ul", null, [
      _createVNode("li", null, [
        _hoisted_4,
        _createVNode("span", null, _toDisplayString(_ctx.place.openingHour) + " - " + _toDisplayString(_ctx.place.closingHour), 1)
      ]),
      _createVNode("li", null, [
        _hoisted_5,
        _createVNode("span", null, _toDisplayString(_ctx.place.openingHour) + " - " + _toDisplayString(_ctx.place.closingHour), 1)
      ]),
      _createVNode("li", null, [
        _hoisted_6,
        _createVNode("span", null, _toDisplayString(_ctx.place.openingHour) + " - " + _toDisplayString(_ctx.place.closingHour), 1)
      ]),
      _createVNode("li", null, [
        _hoisted_7,
        _createVNode("span", null, _toDisplayString(_ctx.place.openingHour) + " - " + _toDisplayString(_ctx.place.closingHour), 1)
      ]),
      _createVNode("li", null, [
        _hoisted_8,
        _createVNode("span", null, _toDisplayString(_ctx.place.openingHour) + " - " + _toDisplayString(_ctx.place.closingHour), 1)
      ]),
      _createVNode("li", null, [
        _hoisted_9,
        _createVNode("span", null, _toDisplayString(_ctx.place.openingHour) + " - " + _toDisplayString(_ctx.place.closingHour), 1)
      ]),
      _hoisted_10
    ])
  ]))
}